import React from 'react';
import SEO from "../common/SEO";
import Layout from '../common/Layout';
import Separator from '../separator/Separator';
import SectionTitle from '../elements/sectionTitle/SectionTitle';
import Timeline from '../elements/timeline/TimeLine';

const Events = () => {
    return (
        <>
            <SEO title="Events IEEE ISSAT Sousse || Events IEEE ISSATSo" />

            <main className="page-wrapper">
                <Layout>
{/**Starting TimeLine */}
<Separator />
                <div className="blog-area">
                    <div className="container">
                        <div className="row"></div>
                            <div className="col-lg-12"></div>
                    <div className="rwt-timeline-area rn-section-gap">
                        
                                <div className="col-lg-12">
                                        <SectionTitle
                                            textAlign = "text-center"
                                            radiusRounded = ""
                                            subtitle = "2021-2022"
                                            title = "Our Latest Programs"
                                        />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12 mb--60">
                                    <Timeline />
                                </div>
                            </div>
                        </div>
                    </div>
                   
                {/**Ending TimeLine */}
                </Layout>
            </main>

        </>
    )
}

export default Events;
